import { render, staticRenderFns } from "./EmpresaDashboardContratos.vue?vue&type=template&id=10c3644b&lang=pug"
import script from "./EmpresaDashboardContratos.vue?vue&type=script&lang=js"
export * from "./EmpresaDashboardContratos.vue?vue&type=script&lang=js"
import style0 from "./EmpresaDashboardContratos.vue?vue&type=style&index=0&id=10c3644b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports